import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll } from 'src/services/Returns';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function Returns() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.returns &&
      res.returns.map((item, i) => {
        return {
          // SELECT r.id, r.invoice_id, r.invoice_detail_id, r.product_id, r.return_date, r.notes, r.returned_rolls, r.returned_yards, r.returned_amount, r.created_by, i.invoice_number AS invoiceNo, p.name AS productName, u.name AS createdBy FROM returns r LEFT JOIN users u ON r.created_by=u.id LEFT JOIN products p ON p.id=r.product_id LEFT JOIN invoices i ON i.id=r.invoice_id WHERE r.deleted_at IS NULL`
          no: i + 1,
          id: item.id,
          invoiceID: item.invoice_id,
          invoiceDetailID: item.invoiceDetailID,
          productID: item.product_id,
          returnDate: formatter('dateOnly', item.return_date),
          rawReturnDate: item.return_date.substring(0, 10),
          notes: item.notes,
          returnedRolls: item.returned_rolls,
          returnedYards: item.returned_yards,
          returnedAmount: formatter('currency', item.returned_amount),
          rawReturnedAmount: item.returned_amount,
          createdBy: item.createdBy,
          invoiceNo: item.invoiceNo,
          productName: item.productName
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'invoiceNo', headerName: 'No Invoice', width: '200' },
      { field: 'productName', headerName: 'Produk', width: '300' },
      { field: 'returnedRolls', headerName: 'Jumlah Retur (Roll)', width: '150' },
      { field: 'returnedYards', headerName: 'Jumlah Retur (Yard)', width: '150' },
      { field: 'returnedAmount', headerName: 'Nilai Retur', width: '150' },
      { field: 'notes', headerName: 'Catatan', width: '200' },
      { field: 'createdBy', headerName: 'Dibuat Oleh', width: '150' },
      { field: 'returnDate', headerName: 'Tanggal Retur', width: '150' }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/return-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Retur </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/return-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel rows={dataRows} columns={dataColumns} excelName="Daftar Produk" config={{ width: '20' }} />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Returns;
